/***
 *
 *   ERROR
 *   Form error message renders below input
 *
 **********/

import type React from 'react';
import { ClassHelper } from 'components/lib';
import Style from './error.tailwind.js';

interface ErrorProps {
  message?: React.ReactNode;
  style?: React.CSSProperties;
  className?: string;
  [key: string]: unknown;
}

export function Error(props: ErrorProps) {
  const errorStyle = ClassHelper(Style, props);

  return (
    <div className={errorStyle} style={props.style}>
      {props.message}
    </div>
  );
}
